import React from "react";

import { GoDownload } from "react-icons/go";
import axios from "axios";
import { decryptText } from "../../../utils/cipherText";
import FinsireButton from "../../../components/FinsireButton";
import { FaPlus } from "react-icons/fa6";

const DistributorTopBar = ({
  searchQuery,
  setSearchQuery,
  showButton,
  downloadPageWord,
  clickFunction,
}) => {
  const userType = decryptText(localStorage.getItem("lender_type"), 7);

  const handlePageDownload = async () => {
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/download_${
          // (downloadPageWord === "transactions" && "transaction") ||
          // (downloadPageWord === "distributors" && "distributor") ||
          // "selected"
          downloadPageWord
        }_csv?page_name=${downloadPageWord}`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res.data.download_url);

      const link = document.createElement("a");
      link.href = res.data.download_url;
      link.download = "data.csv";
      link.textContent = "Download CSV";
      // Append the link to the DOM and trigger the download
      document.body.appendChild(link);
      link.click();
      // Clean up the object URL
      URL.revokeObjectURL(link.href);
      // Remove the link from the DOM
      document.body.removeChild(link);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="flex w-full lg:max-h-14 py-4">
      <div className="flex flex-row justify-between items-center w-full">
        <div>
          <p className="text-[#262626] text-base font-bold">
            List of Distributors
          </p>
        </div>
        <div className="flex flex-row items-center gap-x-4 relative">
          <form className="">
            <div className="relative w-[70%]">
              <input
                value={searchQuery}
                id="search-field"
                className="w-[210px] text-xs h-8 border border-[#E0E0E0] rounded bg-[#F8F8F8] px-3 py-[14px] focus:outline-none placeholder:text-[#848484]"
                placeholder="Search"
                name="search"
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    setSearchQuery(e.target.value);
                  }
                }}
              ></input>
            </div>
          </form>
          <button
            className="border border-[#dadada] rounded w-[32px] h-[32px] flex justify-center items-center "
            onClick={() => handlePageDownload()}
          >
            <GoDownload height={12} width={12} color="#656565" />
          </button>
          {userType !== "distributors" && showButton !== false && (
            <div onClick={() => clickFunction()}>
              <FinsireButton text={"Add Distributor"} icon={FaPlus} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DistributorTopBar;
